import Emissions from './emissions/CohortEmissions';
import CohortCharacteristics from '../../../../common/cohort/containers/characteristics/CohortCharacteristics';
import { useAppDispatch, useAppSelector } from '../../../../../core/rootHooks';
import { RootState } from '../../../../../core/store';
import { vesselCohortVesselSelector } from '../../../../common/cohort/cohortSelector';
import { selectedCohortSourceVesselsSelector } from '../../../../common/cohort/cohortSourceSelector';
import { selectCohortSource, setCohortSource } from '../../../../common/cohort/cohortSourceSlice';
import { IVesselFormData } from '../../../../../shared/sharedTypes';
import DynamicTab from '../../../../../shared/components/tabs/DynamicTab';
import CohortSourceSelect from '../../../../common/cohort/components/CohortSourceSelect';

interface ICohortBenchmarkingProps {
	data: IVesselFormData;
}

const CohortBenchmarking: React.FC<ICohortBenchmarkingProps> = ({ ...props }) => {

	const dispatch = useAppDispatch();
	const cohortSource = useAppSelector(selectCohortSource);

	if (!props.data || !props.data.imoNumber) {
		return;
	}

	const { cohortVessels, minSize, maxSize, rangeSize, minAge, maxAge } = useAppSelector((state: RootState) =>
		selectedCohortSourceVesselsSelector(state, props.data.imoNumber!),
	);

	const vesselForCohort = useAppSelector((state: RootState) => vesselCohortVesselSelector(state, props.data.imoNumber!));

	const tabs = [
		{
			id: 'characteristics',
			label: 'Characteristics',
			content: (
				<CohortCharacteristics
					vessel={vesselForCohort}
					cohortVessels={cohortVessels}
					minSize={minSize}
					maxSize={maxSize}
					rangeSize={rangeSize}
					minAge={minAge}
					maxAge={maxAge}
				/>
			),
		},
		{
			id: 'emissions',
			label: 'Emissions',
			content: <Emissions vessel={vesselForCohort} cohortVessels={cohortVessels} minSize={minSize} maxSize={maxSize} minAge={minAge} maxAge={maxAge} />,
		},
	];

	return (
		<div className="flex flex-col w-full h-full">
			<CohortSourceSelect selected={cohortSource} onChange={(selection) => dispatch(setCohortSource(selection))} />
			<DynamicTab
				items={tabs}
				key={props.data.imoNumber}
				tabColor="msi-chart-midgreen"
				props={{ isVertical: true }}
				giveSpace={false}
				isSubtab
			/>
		</div>
	);
};
export default CohortBenchmarking;
